import { render } from "./RecentPostsList.vue?vue&type=template&id=5c937da1&scoped=true"
const script = {}

import "./RecentPostsList.vue?vue&type=style&index=0&id=5c937da1&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c937da1"]])

export default __exports__